import { LocationFilled } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import { InboundDeliveryOverviewFragment } from "../../../../models/autogenerated-deliveryService-gql/graphql";

interface AddressSectionProps {
  delivery: InboundDeliveryOverviewFragment;
}

const AddressSection = (props: AddressSectionProps) => {
  const { t } = useTranslation();
  const { delivery } = props;

  const renderLocation = delivery.locationResolved
    ? delivery.locationResolved.name || delivery.locationResolved.id
    : t("noLocation");

  return (
    <div data-testid="addressSection">
      <div className="card-list-item-card-row-left" onClick={() => {}}>
        <div className="card-list-item-card-row-item mr-5">
          <LocationFilled size={20} />
        </div>
        <div className="card-list-item-card-row-item-text-overflow">
          {renderLocation}
        </div>
      </div>
    </div>
  );
};
export default AddressSection;
